import React from 'react';
import { motion } from 'framer-motion';
import DocsLayout from '../components/DocsLayout';
import SEO from '../components/SEO';
import { FaDesktop, FaLaptop, FaGamepad, FaTools, FaCompactDisc, FaKey, FaDownload, FaWindows, FaApple, FaUsb, FaChevronRight, FaLightbulb, FaQuestionCircle, FaShoppingCart, FaGraduationCap, FaStar, FaBook, FaCheck, FaInfoCircle } from 'react-icons/fa';

// 导入本地图片资源
import lecooDesktopImg from '../assets/computers/171f3fb6b51cf681.jpg';
import huaweiDesktopImg from '../assets/computers/1da62048baf9ac9f.jpg';
import hpDesktopImg from '../assets/computers/13f3fdba775fccae.jpg';
import acerLaptopImg from '../assets/computers/ae36644c9555f5e1.jpg';
import thinkpadLaptopImg from '../assets/computers/8a2c35451c081901.jpg';
import asusLaptopImg from '../assets/computers/18d735712148315d.jpg';

interface ComputerConfig {
  id: string;
  name: string;
  category: string;
  price: string;
  description: string;
  specs: {
    cpu: string;
    gpu: string;
    ram: string;
    storage: string;
    motherboard?: string;
    cooling?: string;
    psu?: string;
    display?: string;
    features?: string[];
  };
  imageUrl: string;
  recommendedFor: string[];
  link: string;
}

const computerConfigs: ComputerConfig[] = [
  {
    id: 'lecoo-desktop',
    name: '联想来酷 Lecoo一体台式机电脑27英寸',
    category: '台式电脑',
    price: '',
    description: '搭载N5095四核处理器与16GB内存的一体机电脑，采用纤薄设计与27英寸全高清屏幕，提供基础办公与日常娱乐需求的完美解决方案。',
    specs: {
      cpu: 'Intel N5095 四核处理器',
      gpu: '集成显卡',
      ram: '16GB 内存',
      storage: '512GB 固态硬盘',
      display: '27英寸 1920*1080 显示屏',
      features: [
        '纤薄一体机设计',
        '无线键鼠套装',
        'Wi-Fi连接',
        '丰富接口（HDMI、USB3.0×4）'
      ]
    },
    imageUrl: lecooDesktopImg,
    recommendedFor: [
      '家庭日常使用',
      '基础办公',
      '网页浏览',
      '视频娱乐'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BASQJK1olXDYCVV9cDEMVAW4KGlslGVlaCgFtUQ5SQi0DBUVNGFJeSwUIFxlJX3EIGloUWQ4AVl9fCUsIWipURmtJH2MCPT8cdyhlWyROQAURBFB5MBoLBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVV9dDE0nAl8IHV4QXQUGUFZUD0sUM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCZF1tCEoXC2wIGF4VXQMeVF1cCE0SH28OHl4VXgIHXFhZCUsnAW4JH1IlbdiP5CgpCSxXATR_cDpMW29fERiDhfsGcR8KH10STDZnJA5eUQMeBGZAfggRWkRUAxsJTw9yZhdmGVt1WnxFICECAR9LWQt-Xy1LbQMy'
  },
  {
    id: 'huawei-desktop',
    name: '华为MateStation S 商用办公台式电脑主机',
    category: '台式电脑',
    price: '',
    description: '搭载酷睿12代i5六核处理器与16GB内存的高性能商务主机，配备23.8英寸显示器，支持远程开机与超级终端功能，为专业办公提供高效解决方案。',
    specs: {
      cpu: 'Intel Core i5-12400 六核处理器',
      gpu: '集成显卡',
      ram: '16GB 内存',
      storage: '1TB 固态硬盘',
      display: '23.8英寸 1920*1080 显示屏',
      features: [
        '商务办公型号',
        '远程开机功能',
        '超级终端协同',
        '丰富接口（HDMI/DP、USB×8）'
      ]
    },
    imageUrl: huaweiDesktopImg,
    recommendedFor: [
      '企业办公',
      '商务应用',
      '远程工作',
      '多设备协同'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAbsJK1olXDYCVV9cDEgWBGwKH1glGVlaCgFtUQ5SQi0DBUVOBVlUAwoCFxBCHD1WR0VNGFJeSwcYVBYZQTVMFyJvCmFWKDkhbwBeQGlgXwB9NERwMAc-bSUVah1AGQhuCnllCCgcSBx8BWsfW1dhJHZnIy0uSj9-awx_UihXJXNlIjwEWkl3W2d4eQJpGWZZLyk_QRlcdR0Aaz9hIQRiJlYrahJFCxgKcwhuPmVdICcpWzJ0ZCt_GixICH9DCjgVDShgAxBKYyJhPnFLLwIpCjtydBxBTGtWO1YAIgo7SC5OGTAWc1NPWEBSIV4LBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVVteDEMnAl8IHV4QXQUKXF9dAE8WM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCV25eOEsWA2cIGl0UWgIHSF5aDE8XA3MIHV4QXQUKXVZdCEoWM20JGl8cbTbc2e4oC0pqex9XWlJpPF0BUDsC1sanEgRxE1sVXhcyLSQKbx9rZBNvUBJWW25GDzY0SjlzWgxtdVl8L04AByUKdyxLdS5ITDATWTYHZA'
  },
  {
    id: 'hp-desktop',
    name: '惠普 战99 游戏台式电脑主机',
    category: '台式电脑',
    price: '',
    description: '高性能游戏台式主机，搭载i7-14700处理器和RTX4060Ti显卡，32GB大内存，适合游戏、AI训练、渲染和专业创作工作。',
    specs: {
      cpu: 'Intel Core i7-14700 二十核心处理器',
      gpu: 'NVIDIA RTX 4060Ti 光追显卡',
      ram: '32GB 高速内存',
      storage: '1TB SSD + 2TB HDD',
      motherboard: 'H670芯片组主板',
      features: [
        'AI训练与部署优化',
        '大容量存储组合',
        '先进散热系统',
        '专业级图形处理能力'
      ]
    },
    imageUrl: hpDesktopImg,
    recommendedFor: [
      '大型游戏',
      'AI训练部署',
      '3D建模渲染',
      '视频剪辑制作'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAboJK1olXDYCVV9dDUsTC20AHFglGVlaCgFtUQ5SQi0DBUVOBVlUAwoCFxBCHD1WR0VNGFJeSwcYVBYZQTVMF1lKOwRCAwwqWi9-fBkAZDtqFG10Cx8ibSUVUShpUDx8CmBQL1w4fS9UBg8fW1dhJHZnIz0qTzxuWQ9xeCRXJXNlIjwEWkl3W2d4eQJpGWZZLyk_QRlcdR0Aaz9hIQRiJlYrahJFCxgKcwhuPmVdICcpWzJ0ZCt_GixICH9DCjgVDShgAxBKYyJhPnFLLwIpCjtydBxBTGtIFQ5XEycufClHfRJccD1eGWN6ABULBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVV9dDE8nAl8IHV4QXQQDXF1ZCUkQM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCV25eOEsWA2YMElgSXQUBSF5YAE4SAHMIHV4QXQQDXV5cAU0RM20JGl8cbTbc2so9ekl3e21jQCBSWV0BKV061sWDEh1jG18QTDYACzhfSBxFdD1sciRjVXliKxc2fhRWfApmGQlSPE1lPQk7WjAVZhpsWF51bQMy'
  },
  {
    id: 'acer-laptop',
    name: '宏碁(acer)非凡GO16 笔记本电脑',
    category: '笔记本电脑',
    price: '',
    description: '搭载i5-13500H处理器的16英寸轻薄本，金属机身设计，16GB内存和1TB大容量SSD，适合学生和商务人士使用。',
    specs: {
      cpu: 'Intel Core i5-13500H (2.6GHz-4.7GHz)',
      gpu: 'INTEL IRIS XE 集成显卡',
      ram: '16GB 内存(4800MHz)',
      storage: '1TB 固态硬盘',
      display: '16英寸 1920*1200 IPS屏幕(100% sRGB)',
      features: [
        '金属机身，轻薄便携(1.7kg)',
        '58Wh大电池，续航持久',
        '单色背光键盘',
        '支持Wi-Fi 6双天线'
      ]
    },
    imageUrl: acerLaptopImg,
    recommendedFor: [
      '学生日常使用',
      '商务办公',
      '文档处理',
      '多媒体娱乐'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAS8JK1olXwQAVVxdDE4UBV8IGlsVWQIBVFxVCEkUBF9MRANLAjZbERscSkAJHTdNTwcKBlMdBgABFksWA28MH1gVXw4CVl1aFxJSXzI4RllsKk5HPT4-dVFiZy0IU1NwWUd-ElJROEonA24JG14dWgAAUm5tCEwnQgEIGloWXQ4FUW5cOEsRBmoIGVoUXw8BVl5tD0seM2gAE1oWVAQLSFhUCkwSBF84K1glWgYLQFgvSRkDBR04K1slXjYCVV5VC0sUAW4LH0cVWQMHVlpBCE0SBm8KGloWXQUKXG5fCUoTCl84xdalLw5cJDgqUBMeBxNdS1kQLdiP5E8veEkTBWgZKyljOloLKgseXStFRRABaT8dL2cAMh4WWiUVdRZPaD1HJ31XEwMcSB8UeGw4Hms'
  },
  {
    id: 'thinkpad-laptop',
    name: 'ThinkPad E14 笔记本电脑',
    category: '笔记本电脑',
    price: '',
    description: '全新酷睿Ultra7处理器的AI PC商务本，轻薄设计，32GB大内存和1TB存储，2.2K高清屏幕，提供卓越商务办公体验。',
    specs: {
      cpu: 'Core Ultra7 155H 处理器(22线程)',
      gpu: '集成显卡',
      ram: '32GB 内存(5600MHz)',
      storage: '1TB 固态硬盘',
      display: '14英寸 2240*1400 IPS屏幕(100% sRGB)',
      features: [
        '轻薄机身(1.43kg)',
        '57Wh电池',
        '支持Wi-Fi 6双天线',
        '提供雷电/USB4接口'
      ]
    },
    imageUrl: thinkpadLaptopImg,
    recommendedFor: [
      '商务办公',
      'AI应用',
      '数据处理',
      '高效工作'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAS8JK1olXwEDVlxfCEsWBl8IGloUXAcKVFxcCUknRzBQRQQlBENHFRxWFlVPRjtUBABAQlRcCEBdCUoXB2wMGV0WVAEdDRsBVXt-CiZxYitJCGQFNishfSgVfihPcEVTUQoyVW5dCUoXBmcPHVkTbTYCU24OZg5OWzBSWgtAQV1JEW5cOEsRBmoIGFwVVQIBVFttD0seM2gAE1oWVAQLSFhUCkwSBF84K1glWgYLQFgvSRkDBR04K1slXjYCVV5UAUIVA2gIH0cVXg8HVllBCE0SBm8LHFsQXQQGV25fCUoTCl84xdalIQJEPVlVDTZKBitKeDJcDtiP5E82cUMXA2wZKyx-K3MEFjsVbSgTWhJIWwJNNk4BVSwLYSUVZBxhEiRjNWFnUCMZUU5WZyg4Hms'
  },
  {
    id: 'asus-laptop',
    name: '华硕灵耀14 Air 笔记本电脑',
    category: '笔记本电脑',
    price: '',
    description: '搭载Ultra7 258V处理器的超轻薄笔记本，2.8K 120Hz OLED屏幕，仅1.1cm厚，32GB内存和1TB存储，支持Wi-Fi 7。',
    specs: {
      cpu: 'Intel Core Ultra 7 258V处理器',
      gpu: '集成显卡',
      ram: '32GB 内存(8533MHz)',
      storage: '1TB 固态硬盘',
      display: '14英寸 2880*1800 OLED屏幕(120Hz,100% DCI-P3)',
      features: [
        '超轻薄设计(1.15kg,1.1cm厚)',
        '72Wh大电池',
        '支持Wi-Fi 7',
        '全面屏设计'
      ]
    },
    imageUrl: asusLaptopImg,
    recommendedFor: [
      '高端商务',
      '内容创作',
      '移动办公',
      '视频娱乐'
    ],
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAbsJK1olXDYCVV9dDUMfB2oAG14lGVlaCgFtUQ5SQi0DBUVOBVlUAwoCFxBCHD1WR0VNGFJeSwcYVBYZQTVMFz0VC1tkACMddTB1WwhDeg50HlABUgtcTCUVcw1QYCMVWX5_DQEOWBFfBjQfW1dhJHZnIz0qVz1uZwZxeDhVJXNlIjwEWkl3W2d4eQJpGWZZLyk_QRlcdR0Aaz9hIQRiJlYrahJFCxgKcwhuPmVdICcpWzJ0ZCt_GixICH9DCjgVDShgAxBKYyJhPnFLLwIpCjtydBxBTGt-XlFBAhhDeC5CVz9-fFJlA1p6SjkLBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVV9dAUgnAl8IHV4QXQQDV19ZCEsRM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCV25eOEsWA2YMHFwSWwYESF5fAE0UA3MIHV4QXQQDVFlbAEwQM20JGl8cbTbc2sotC0tTZh1pWwxeXWN0AQcE1sWDEhNsH1sUWBcyMl4LVS1Dfi91YDlNOk1jAT8eXkgRVm5MdVllP155LF5ZcDZOXDxYQRMQBjYHZA'
  }
];

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
];

const ComputerRecommend: React.FC = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="电脑装机配置推荐 | 不同场景台式机笔记本选购指南"
        description="2024年最新电脑配置推荐，包括入门办公、中端全能和高端游戏创作三个档位的电脑配置单，帮你轻松挑选适合自己预算和需求的台式电脑与笔记本。"
        keywords="电脑配置推荐,装机配置单,台式机推荐,笔记本推荐,游戏电脑配置,办公电脑配置,电脑配置清单,电脑选购指南,笔记本电脑选购"
      />
      <div className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl font-bold mb-6 text-gray-800"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          电脑选购推荐指南
        </motion.h1>
        
        <motion.div 
          className="mb-8 bg-blue-50 p-5 rounded-lg shadow-sm border border-blue-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3 className="text-xl font-semibold text-blue-800 mb-3 flex items-center">
            <FaLightbulb className="mr-2" /> 选购指南
          </h3>
          <p className="text-gray-700 mb-3">
            选择适合自己需求的电脑配置是一项重要的决策。我们根据不同用户需求和预算，精心推荐了以下几款配置方案：
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>根据用途选择：办公、学习、游戏、创作各有侧重</li>
            <li>考虑预算与性能平衡，避免过度或不足配置</li>
            <li>台式机扩展性更好，笔记本便携性更强</li>
            <li>关注核心配件：处理器、显卡、内存和存储是决定性能的关键</li>
          </ul>
          
          {/* 课程卡片 */}
          <motion.div 
            className="mt-6 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl border border-pink-200 shadow-md overflow-hidden"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            whileHover={{ y: -5 }}
          >
            <div className="p-5">
              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="flex-shrink-0 bg-gradient-to-br from-pink-100 to-purple-100 p-4 rounded-lg border border-pink-200 flex items-center justify-center">
                  <FaGraduationCap className="text-5xl text-pink-500" />
                </div>
                
                <div className="flex-grow">
                  <div className="flex items-start justify-between flex-wrap">
                    <h3 className="text-xl font-bold text-purple-800 flex items-center">
                      电脑选购速成课
                      <span className="ml-2 inline-flex">
                        <FaStar className="text-yellow-400" />
                        <FaStar className="text-yellow-400" />
                        <FaStar className="text-yellow-400" />
                        <FaStar className="text-yellow-400" />
                        <FaStar className="text-yellow-400" />
                      </span>
                    </h3>
                    <span className="bg-gradient-to-r from-pink-500 to-purple-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm mt-1">
                      推荐课程
                    </span>
                  </div>
                  
                  <p className="text-gray-700 my-2">教你看懂配置参数，掌握购买秘诀，避开商家套路，轻松选到性价比最高的电脑</p>
                  
                  <div className="flex flex-wrap gap-2 mb-3">
                    <span className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded-full font-medium">配置解析</span>
                    <span className="bg-pink-100 text-pink-700 text-xs px-2 py-1 rounded-full font-medium">避坑指南</span>
                    <span className="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full font-medium">实战技巧</span>
                    <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full font-medium">性价比推荐</span>
                  </div>
                  
                  <div className="flex items-center text-pink-600 text-sm font-medium">
                    <FaBook className="mr-1" /> 课程内容包含：
                  </div>
                  <ul className="text-xs text-gray-600 grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1 mt-1">
                    <li className="flex items-center">
                      <FaChevronRight className="text-pink-400 flex-shrink-0 mr-1" size={8} />
                      <span>CPU/显卡选择与性能评估</span>
                    </li>
                    <li className="flex items-center">
                      <FaChevronRight className="text-pink-400 flex-shrink-0 mr-1" size={8} />
                      <span>内存/存储设备挑选技巧</span>
                    </li>
                    <li className="flex items-center">
                      <FaChevronRight className="text-pink-400 flex-shrink-0 mr-1" size={8} />
                      <span>主板/电源/散热器选购指南</span>
                    </li>
                    <li className="flex items-center">
                      <FaChevronRight className="text-pink-400 flex-shrink-0 mr-1" size={8} />
                      <span>显示器规格与画质解析</span>
                    </li>
                  </ul>
                  
                  <a 
                    href="https://item.taobao.com/item.htm?id=807698667154&spm=a21xtw.29178619.product_shelf.1.364527edINfbzw" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="mt-3 inline-block bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white py-2 px-4 rounded-lg transition-colors font-medium shadow-sm flex items-center"
                  >
                    <FaShoppingCart className="mr-2" /> 获取课程
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
        
        <div className="grid grid-cols-1 gap-8">
          {/* 台式电脑部分 */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h2 className="text-2xl font-bold mb-4 text-gray-800 flex items-center">
              <FaDesktop className="mr-2 text-blue-600" /> 台式电脑推荐
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {computerConfigs.filter(config => config.category === '台式电脑').map((computer, index) => (
                <motion.div 
                  key={computer.id}
                  className="bg-gradient-to-br from-white to-gray-50 rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all hover:translate-y-[-2px]"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                >
                  <div className="p-5">
                    <div className="mb-4">
                      <div className="w-full h-48 bg-white rounded-md overflow-hidden border border-gray-100 shadow-sm mb-4">
                        <img src={computer.imageUrl} alt={computer.name} className="w-full h-full object-cover" />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">{computer.name}</h3>
                      <div className="flex items-center mt-2">
                        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                          {computer.price}
                        </span>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 text-sm mb-4">{computer.description}</p>
                    
                    <div className="mb-4">
                      <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                        <FaLaptop className="text-blue-500 mr-2" size={16} />
                        配置详情：
                      </h4>
                      <ul className="text-sm text-gray-600 space-y-2">
                        <li className="flex items-start">
                          <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>CPU:</b> {computer.specs.cpu}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>显卡:</b> {computer.specs.gpu}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>内存:</b> {computer.specs.ram}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>存储:</b> {computer.specs.storage}</span>
                        </li>
                        {computer.specs.motherboard && (
                          <li className="flex items-start">
                            <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                            <span><b>主板:</b> {computer.specs.motherboard}</span>
                          </li>
                        )}
                        {computer.specs.cooling && (
                          <li className="flex items-start">
                            <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                            <span><b>散热:</b> {computer.specs.cooling}</span>
                          </li>
                        )}
                        {computer.specs.psu && (
                          <li className="flex items-start">
                            <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                            <span><b>电源:</b> {computer.specs.psu}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                    
                    <div className="mb-4">
                      <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                        <FaGamepad className="text-green-500 mr-2" size={16} />
                        推荐用途：
                      </h4>
                      <div className="flex flex-wrap gap-1">
                        {computer.recommendedFor.map((use, idx) => (
                          <span key={idx} className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                            {use}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <a 
                      href={computer.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-center py-2 px-4 rounded-md transition-colors font-medium shadow-sm"
                    >
                      参考链接
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          {/* 笔记本电脑部分 */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <h2 className="text-2xl font-bold mb-4 text-gray-800 flex items-center mt-10">
              <FaLaptop className="mr-2 text-purple-600" /> 笔记本电脑推荐
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {computerConfigs.filter(config => config.category === '笔记本电脑').map((computer, index) => (
                <motion.div 
                  key={computer.id}
                  className="bg-gradient-to-br from-white to-gray-50 rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all hover:translate-y-[-2px]"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                >
                  <div className="p-5">
                    <div className="mb-4">
                      <div className="w-full h-48 bg-white rounded-md overflow-hidden border border-gray-100 shadow-sm mb-4">
                        <img src={computer.imageUrl} alt={computer.name} className="w-full h-full object-cover" />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">{computer.name}</h3>
                      <div className="flex items-center mt-2">
                        <span className="inline-block bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">
                          {computer.price}
                        </span>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 text-sm mb-4">{computer.description}</p>
                    
                    <div className="mb-4">
                      <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                        <FaLaptop className="text-purple-500 mr-2" size={16} />
                        配置详情：
                      </h4>
                      <ul className="text-sm text-gray-600 space-y-2">
                        <li className="flex items-start">
                          <FaChevronRight className="text-purple-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>CPU:</b> {computer.specs.cpu}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-purple-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>显卡:</b> {computer.specs.gpu}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-purple-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>内存:</b> {computer.specs.ram}</span>
                        </li>
                        <li className="flex items-start">
                          <FaChevronRight className="text-purple-500 flex-shrink-0 mt-1 mr-2" size={12} />
                          <span><b>存储:</b> {computer.specs.storage}</span>
                        </li>
                        {computer.specs.display && (
                          <li className="flex items-start">
                            <FaChevronRight className="text-purple-500 flex-shrink-0 mt-1 mr-2" size={12} />
                            <span><b>屏幕:</b> {computer.specs.display}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                    
                    {computer.specs.features && (
                      <div className="mb-4">
                        <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                          <FaLightbulb className="text-amber-500 mr-2" size={16} />
                          特色功能：
                        </h4>
                        <ul className="text-sm text-gray-600 space-y-2">
                          {computer.specs.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start">
                              <FaChevronRight className="text-amber-500 flex-shrink-0 mt-1 mr-2" size={12} />
                              <span>{feature}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    <div className="mb-4">
                      <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                        <FaGamepad className="text-green-500 mr-2" size={16} />
                        推荐用途：
                      </h4>
                      <div className="flex flex-wrap gap-1">
                        {computer.recommendedFor.map((use, idx) => (
                          <span key={idx} className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                            {use}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <a 
                      href={computer.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white text-center py-2 px-4 rounded-md transition-colors font-medium shadow-sm"
                    >
                      参考链接
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
        
        <motion.div 
          className="mt-10 bg-yellow-50 p-5 rounded-lg shadow-sm border border-yellow-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.7 }}
        >
          <h3 className="text-lg font-semibold text-amber-800 mb-3 flex items-center">
            <FaQuestionCircle className="mr-2" /> 电脑选购小贴士
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li><b>升级空间：</b>台式机通常有更好的升级空间，而笔记本多数组件难以更换。</li>
            <li><b>性能差异：</b>同等配置下，台式机通常性能更好，散热更出色，价格更低。</li>
            <li><b>配件选择：</b>选购台式机时，电源和主板质量非常重要，它们关系到系统的稳定性和使用寿命。</li>
            <li><b>笔记本屏幕：</b>选购笔记本时，屏幕素质（分辨率、色域、亮度、刷新率）是重要考虑因素。</li>
            <li><b>预算分配：</b>有限预算下，建议优先保证CPU和显卡的性能，其次是内存和存储。</li>
            <li><b>品牌选择：</b>选择有良好售后服务和口碑的品牌，可以减少后期使用的烦恼。</li>
          </ul>
        </motion.div>
      </div>
    </DocsLayout>
  );
};

export default ComputerRecommend;